module.exports = __webpack_public_path__ + "img/sugar.8060c50.png";